import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { useTranslation } from 'react-i18next'
import { Drawer, StepList } from '@boltenergy-be/design-system'
import { useState } from 'react'
import { WelcomeDrawerListKeys } from 'pages/app/overview/overview-cards/welcome/types.ts'
import dayjs from 'dayjs'
import { useStoreSelector } from 'hooks/store.ts'
import { selectCurrentServiceContracts, selectIsProducerAccount } from 'store/contact/slice.ts'

const WelcomeOverviewCard = () => {
  // Redux
  const isProducer = useStoreSelector(selectIsProducerAccount)
  const { electricity } = useStoreSelector(selectCurrentServiceContracts)

  // i18n
  const { t } = useTranslation('overview')

  // Local state
  const [overviewCardDrawer, setOverviewCardDrawer] = useState<boolean>(false)

  // Constants
  const hasBeenSubscribedForMoreThanOneMonth = dayjs(electricity?.detail?.subscriptionDate).isBefore(dayjs().subtract(1, 'month'))
  const welcomeTranslationKey = isProducer ? 'welcomeProducer' : 'welcome'

  if (hasBeenSubscribedForMoreThanOneMonth) {
    return null
  }

  return (
    <>
      <OverviewCard
        button={{
          label: t(($) => $[welcomeTranslationKey].button),
          onClick: () => setOverviewCardDrawer(true),
          id: !hasBeenSubscribedForMoreThanOneMonth ? 'beta-welcome' : 'welcome'
        }}
        color="vibrant"
      >
        <OverviewCard.Title>{t(($) => $[welcomeTranslationKey].title)}</OverviewCard.Title>
        <p>{t(($) => $[welcomeTranslationKey].description)}</p>
      </OverviewCard>

      <Drawer
        isOpen={overviewCardDrawer}
        title={t(($) => $[welcomeTranslationKey].drawer.title)}
        onRequestClose={() => setOverviewCardDrawer(false)}
      >
        <p>{t(($) => $[welcomeTranslationKey].drawer.description)}</p>

        <StepList size="medium">
          {Array.from({ length: isProducer ? 5 : 6 }).map((_, index) => (
            <li key={index}>
              <strong>{t(($) => $[welcomeTranslationKey].drawer.steps[(index + 1) as WelcomeDrawerListKeys].title)}</strong>
              <p>{t(($) => $[welcomeTranslationKey].drawer.steps[(index + 1) as WelcomeDrawerListKeys].description)}</p>
            </li>
          ))}
        </StepList>
      </Drawer>
    </>
  )
}

export default WelcomeOverviewCard
